import { STRINGS } from '../../constants/workshop';
import filterEmptyParams from '../../utils/filters';
import apiCaller from '../http';
import URLS from '../urls';

const createServiceReport = async (
  visitId,
  value,
  setError,
  setIsModalVisible,
  setIsLoading,
  logoutHandler,
) => {
  const { brake, coolant, lights, mileage, oil, tires } = value;
  const payload = {
    brake_fluid_condition: brake,
    coolant_condition: coolant,
    lights_condition: lights,
    mileage,
    oil_condition: oil,
    tires_condition: tires,
  };
  await apiCaller
    .post(`${URLS.SERVICE_REPORT_CREATE}${visitId}/`, filterEmptyParams(payload))
    .then(() => {
      setError(null);
      setIsModalVisible(false);
    })
    .catch((e) => {
      setIsLoading(false);
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.response?.data[0] === STRINGS.visitDetail.errorMileageTemplate) {
        setError(STRINGS.visitDetail.errorMileageText);
      } else if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400Text);
      }
    });
};

export default createServiceReport;
